import { legacySizes } from '~/constants/common/resizeBreakpoints';
import { useResizeListener } from '~/hooks/common';
import {
  useFetchDeviceDetection,
  useGeolocation,
  useTrackClickEvents
} from '~/hooks/common';
import { useGetFavorites } from '~/hooks/common/favorites';
import useSendViewedEvent from '~/hooks/common/useSendViewedEvent';
import useNoScroll from '~/hooks/giveaway/useNoScroll';
import setLocalBrowserCookieId from '~/pages-utils/setLocalBrowserCookieId';

function GiveawayData() {
  setLocalBrowserCookieId();
  useSendViewedEvent('Red Bull Landing Page Viewed');
  useTrackClickEvents();
  useResizeListener(legacySizes);
  useGeolocation();
  useFetchDeviceDetection();
  useGetFavorites();
  useNoScroll();

  return null;
}

export default GiveawayData;
